import { __decorate } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Input, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

let UiCPixDevolutionTransferDataService = class UiCPixDevolutionTransferDataService {
    constructor() { }
};
UiCPixDevolutionTransferDataService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCPixDevolutionTransferDataService_Factory() { return new UiCPixDevolutionTransferDataService(); }, token: UiCPixDevolutionTransferDataService, providedIn: "root" });
UiCPixDevolutionTransferDataService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], UiCPixDevolutionTransferDataService);

let UiCPixDevolutionTransferDataComponent = class UiCPixDevolutionTransferDataComponent {
    constructor() { }
    set setFlag(flag) {
        if (flag !== undefined || flag !== null) {
            this.contextControl();
        }
    }
    ngOnInit() {
        this.dateToShow = new Date();
        this.contextTray = false;
        this.btnIcon = 'chevron-down-outline';
    }
    contextControl() {
        this.contextTray = this.contextTray ? false : true;
        this.btnIcon = this.contextTray ? 'chevron-up-outline' : 'chevron-down-outline';
    }
};
__decorate([
    Input()
], UiCPixDevolutionTransferDataComponent.prototype, "title", void 0);
__decorate([
    Input()
], UiCPixDevolutionTransferDataComponent.prototype, "titleBox", void 0);
__decorate([
    Input()
], UiCPixDevolutionTransferDataComponent.prototype, "username", void 0);
__decorate([
    Input()
], UiCPixDevolutionTransferDataComponent.prototype, "date", void 0);
__decorate([
    Input()
], UiCPixDevolutionTransferDataComponent.prototype, "value", void 0);
__decorate([
    Input()
], UiCPixDevolutionTransferDataComponent.prototype, "setFlag", null);
UiCPixDevolutionTransferDataComponent = __decorate([
    Component({
        selector: 'ui-c-pix-devolution-transfer-data',
        template: "<h3> {{ title }} </h3>\n\n<ion-grid class=\"transfer-devolution-success-tray\">\n  <ion-row class=\"row align-content-start\">\n    <ion-col class=\"col-2\">\n      <div class=\"circle-transfer-icon sender\">\n        <ion-icon name=\"qr-code-outline\"></ion-icon>\n      </div>\n    </ion-col>\n    <ion-col class=\"col-10\">\n      <ion-text color=\"dark\">\n        <h6 class=\"font-weight-bold\"> {{ titleBox }} </h6>\n      </ion-text>\n\n      <ion-grid (click)=\"contextControl()\">\n        <ion-row class=\"row align-content-center\">\n          <ion-col class=\"col-7\">\n            <p> {{ username }} </p>\n            <p class=\"ion-text-uppercase\"> {{ date | date:'dd LLL hh:mm:ss' }} </p>\n          </ion-col>\n          <ion-col class=\"col-5\">\n            <p> {{ value | currency:'BRL' }} <ion-icon [name]=\"btnIcon\"></ion-icon>\n            </p>\n          </ion-col>\n        </ion-row>\n\n        <ion-row class=\"context-tray\" [ngClass]=\"{'show-context': contextTray}\">\n          <ion-col class=\"px-0 mx-0\">\n            <div class=\"box-data-transfer\">\n              <ng-content></ng-content>\n            </div>\n          </ion-col>\n        </ion-row>\n      </ion-grid>\n\n    </ion-col>\n  </ion-row>\n</ion-grid>\n",
        styles: [""]
    })
], UiCPixDevolutionTransferDataComponent);

let UiCPixDevolutionTransferDataModule = class UiCPixDevolutionTransferDataModule {
};
UiCPixDevolutionTransferDataModule = __decorate([
    NgModule({
        declarations: [UiCPixDevolutionTransferDataComponent],
        exports: [UiCPixDevolutionTransferDataComponent],
        imports: [CommonModule, IonicModule],
    })
], UiCPixDevolutionTransferDataModule);

/*
 * Public API Surface of ui-c-pix-devolution-transfer-data
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCPixDevolutionTransferDataComponent, UiCPixDevolutionTransferDataModule, UiCPixDevolutionTransferDataService };
//# sourceMappingURL=wlp-ui-c-pix-devolution-transfer-data.js.map
